import { Globe, ChevronDown } from "lucide-react";
import { cn } from "@/lib/utils";
import { useLanguageSelector } from "./useLanguageSelector";

export function LanguageSelector() {
  const {
    isOpen,
    selectedLang,
    toggleOpen,
    close,
    selectLanguage,
    languages,
  } = useLanguageSelector();

  return (
    <div className="relative">
      <button
        onClick={toggleOpen}
        className="flex items-center gap-2 px-3 py-2 rounded-xl text-sm font-medium text-muted-foreground hover:text-foreground hover:bg-secondary/50 transition-all"
      >
        <Globe className="w-4 h-4" />
        <span>{selectedLang.flag}</span>
        <ChevronDown
          className={cn(
            "w-4 h-4 transition-transform",
            isOpen && "rotate-180"
          )}
        />
      </button>

      {isOpen && (
        <>
          <div className="fixed inset-0 z-40" onClick={close} />
          <div className="absolute bottom-full mb-2 start-0 bg-card border border-border rounded-2xl shadow-xl overflow-hidden z-50 min-w-[160px]">
            {languages.map((lang) => (
              <button
                key={lang.code}
                onClick={() => selectLanguage(lang.code)}
                className={cn(
                  "w-full flex items-center gap-3 px-4 py-3 text-sm font-medium transition-colors text-start",
                  selectedLang.code === lang.code
                    ? "bg-primary/10 text-primary"
                    : "text-muted-foreground hover:bg-secondary/50 hover:text-foreground"
                )}
              >
                <span className="text-lg">{lang.flag}</span>
                <span>{lang.label}</span>
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
